module.exports = __webpack_public_path__ + "img/danger.ac55348f.svg";